import CityPageTemplate from "../city-template/CityPageTemplate";
import { greenbeltConfig } from "./data";

export default function GreenbeltPage() {
  return <CityPageTemplate config={greenbeltConfig} />;
}